// Context that carries a dedicated search page's identity down the shared
// search layout. Value shape: { config, DEFAULTS }.
//   - config:   the page's registry entry from src/config/searchPages.js,
//               or null on the plain /Buscar page.
//   - DEFAULTS: the state every "default" comparison must use — EMPTY_STATE
//               overlaid with the page's presets. On /Buscar this is
//               EMPTY_STATE itself (same reference), so identity checks and
//               today's behavior are untouched.
// Every consumer must treat a null context (or null config) as "behave
// exactly like the plain search page".

import { createContext, useContext } from "react";

export const SearchPageContext = createContext(null);

export const useSearchPage = () => useContext(SearchPageContext);
